import { combineReducers } from "redux"

// Authentication
import auth from "./auth/login/reducer"
import login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"
import Data from "./auth/data/reducer"

const rootReducer = combineReducers({
  // public
  auth,
  login,
  Account,
  ForgetPassword,
  Profile,
  Data
})

export default rootReducer
